var ListViewRequest = function ListViewRequest() {
  this.ValueSet = {};
  this.AttributeSet = {};
  this.FirstQuery = true;
  this.Query = {};
  this.OrderBy = "";
  this.Paging = {
    TotalCount: 0,
    RecordPerPage: 10,
    CurrentPageNumber: 1
  };
  this.Bag = {};
  this.Rows = [];
  this.SelectedRows = [];
  this.SelectedRowsFromRequest = [];
};

export default ListViewRequest;